export const checkDate = (date?: string) => {
  if (date && !isNaN(Date.parse(date))) {
    return true;
  }

  return false;
};
